export const isBrowser = typeof window !== 'undefined';
export const isDevice = () => isBrowser && window.matchMedia('(max-width: 768px)').matches;